export enum SupplyTab {
  Apps = 'apps',
  Domains = 'domains',
  Tailored = 'tailored-supply',
}

import { optionalPositiveInteger, optionalTrimmedString } from '../../../lib/routeSearch';
import { defaultSupplyListFilter, type SupplyListFilter } from './model';

export type SupplyRouteSearch = { search?: string; page?: number; size?: number };

export function supplyRouteSearchSchema(search: Record<string, unknown>): SupplyRouteSearch {
  const searchTerm = optionalTrimmedString(search['search']);
  const page = optionalPositiveInteger(search['page']);
  const size = optionalPositiveInteger(search['size']);
  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(page ? { page } : {}),
    ...(size ? { size } : {}),
  };
}

export function parseSupplyRouteSearch(search: SupplyRouteSearch): SupplyListFilter {
  return {
    searchTerm: search.search ?? defaultSupplyListFilter.searchTerm,
    page: search.page ? search.page - 1 : defaultSupplyListFilter.page,
    size: search.size ?? defaultSupplyListFilter.size,
  };
}

export function serializeSupplyRouteSearch(filter: SupplyListFilter): SupplyRouteSearch {
  return {
    ...(filter.searchTerm.trim() ? { search: filter.searchTerm.trim() } : {}),
    ...(filter.page ? { page: filter.page + 1 } : {}),
    ...(filter.size !== defaultSupplyListFilter.size ? { size: filter.size } : {}),
  };
}
